import React from 'react';
import { AlertCircle, XCircle, Clock, TrendingDown, CreditCard, Landmark } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 lg:py-32 bg-cream text-navy-dark" data-id="element-111">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-112">
        {/* The Hook */}
        <div className="mb-20" data-id="element-113">
          <p className="font-heading text-2xl md:text-3xl lg:text-4xl leading-relaxed text-navy font-medium italic border-l-4 border-gold pl-6 md:pl-10" data-id="element-114">
            "Son las 11 de la noche. Suena un ruido extraño en el motor del
            coche o un hijo se despierta con un dolor de muela que no puede
            esperar."
          </p>
          <p className="mt-8 text-lg md:text-xl text-navy-light leading-relaxed" data-id="element-115">
            Sientes ese frío en la espalda. No es miedo a la enfermedad o a la
            avería; es el pánico de saber que no tienes $400 libres en la
            tarjeta y que el banco no te dará ni un centavo más. Vivir así no es
            vivir, es sobrevivir en una emboscada constante.
          </p>
        </div>

        {/* The Problem */}
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-cream-dark mb-20 relative overflow-hidden" data-id="element-116">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-50 rounded-bl-full -z-0" data-id="element-117"></div>
          <div className="relative z-10" data-id="element-118">
            <div className="flex items-center gap-3 mb-6" data-id="element-119">
              <AlertCircle className="text-red-500 w-8 h-8" data-id="element-120" />
              <h2 className="font-heading text-3xl font-bold text-navy" data-id="element-121">
                La Vulnerabilidad de 24 Horas
              </h2>
            </div>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-122">
              La mayoría de las familias operan bajo esta vulnerabilidad. Si hoy
              ocurriera un imprevisto de $500, su mundo financiero colapsaría.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-123">
              Has intentado ahorrar, pero el dinero parece "evaporarse" antes de
              llegar al día 15. Has intentado usar aplicaciones de presupuesto,
              pero Excel no paga una llanta ponchada a mitad de la carretera. El
              problema no es lo que ganas, sino que{' '}
              <strong className="text-navy" data-id="element-124">
                tu dinero no tiene arquitectura de defensa
              </strong>
              . Estás a un solo imprevisto de la quiebra emocional.
            </p>
          </div>
        </div>

        {/* Why what you tried didn't work */}
        <div data-id="element-125">
          <h3 className="font-heading text-3xl font-bold text-center mb-12 text-navy" data-id="element-126">
            Por qué lo que has intentado hasta hoy ha fallado
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-127">
            <div className="bg-cream-dark/30 p-6 rounded-xl border border-cream-dark flex gap-4 items-start" data-id="element-128">
              <div className="bg-white p-2 rounded-lg shadow-sm shrink-0" data-id="element-129">
                <Clock className="text-navy w-6 h-6" data-id="element-130" />
              </div>
              <div data-id="element-131">
                <h4 className="font-bold text-navy mb-2" data-id="element-132">
                  Presupuestos Rígidos
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-133">
                  Asumen que tu vida es perfecta, ignorando que los imprevistos
                  son la única constante.
                </p>
              </div>
            </div>

            <div className="bg-cream-dark/30 p-6 rounded-xl border border-cream-dark flex gap-4 items-start" data-id="element-134">
              <div className="bg-white p-2 rounded-lg shadow-sm shrink-0" data-id="element-135">
                <TrendingDown className="text-navy w-6 h-6" data-id="element-136" />
              </div>
              <div data-id="element-137">
                <h4 className="font-bold text-navy mb-2" data-id="element-138">
                  Ahorrar "lo que sobra"
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-139">
                  Es una trampa mental: el dinero siempre se expande para llenar
                  tus facturas si no lo bloqueas primero.
                </p>
              </div>
            </div>

            <div className="bg-cream-dark/30 p-6 rounded-xl border border-cream-dark flex gap-4 items-start" data-id="element-140">
              <div className="bg-white p-2 rounded-lg shadow-sm shrink-0" data-id="element-141">
                <CreditCard className="text-navy w-6 h-6" data-id="element-142" />
              </div>
              <div data-id="element-143">
                <h4 className="font-bold text-navy mb-2" data-id="element-144">
                  La Tarjeta como Fondo
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-145">
                  Es apagar un incendio con gasolina, creando intereses que te
                  roban el oxígeno del próximo mes.
                </p>
              </div>
            </div>

            <div className="bg-cream-dark/30 p-6 rounded-xl border border-cream-dark flex gap-4 items-start" data-id="element-146">
              <div className="bg-white p-2 rounded-lg shadow-sm shrink-0" data-id="element-147">
                <Landmark className="text-navy w-6 h-6" data-id="element-148" />
              </div>
              <div data-id="element-149">
                <h4 className="font-bold text-navy mb-2" data-id="element-150">
                  Todo en una sola cuenta
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-151">
                  Te obliga a pelear contra tus propios impulsos cada vez que
                  abres la banca online.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}